import React, { useState } from 'react';
import FilterSearch from './filters/FilterSearch';
import FilterCheckbox from './filters/FilterCheckbox';
import FilterSelect from './filters/FilterSelect';
import FilterAccordionMultiSelect from './filters/FilterAccordionMultiSelect';
import FilterAccordionSingleSelect from './filters/FilterAccordionSingleSelect';
import FilterButtonGroup from './filters/FilterButtonGroup';
import FilterOrderBy from './filters/FilterOrderBy';
import FilterDate from './filters/FilterDate';
import FilterIcon from '../assets/images/icons/FilterIcon.svgr';
import FilterIconRed from '../assets/images/icons/FilterIconRed.svgr';
import CloseIcon from '../assets/images/icons/CloseIcon.svgr';
import { throttle } from 'lodash';

function sidebar(props) {
    const [modalVisible, setModalVisible] = useState(false);

    const {
        layout,
        filters,
        results,
        currentSearchTerm,
        selected,
        mobileStyle,
        displayPostCounts,
        order,
        autoLoadFilters,
        filterReset,
        sidebarLeft,
        sidebarRight,
        displayReset,
        displayResults,
        displaySort,
        displaySearch,

        orderChange,
        toggleSelected,
        replaceSelected,
        isSelected,
        resetSelected,
        searchFieldChange,
        setCurrentPage,
        setChangedFilter,
        setFilterReset,
    } = props;

    const className = props.className ? props.className : '';

    const components = {
        checkbox: FilterCheckbox,
        select: FilterSelect,
        'button-group': FilterButtonGroup,
        'accordion-multi-select': FilterAccordionMultiSelect,
        'accordion-single-select': FilterAccordionSingleSelect,
        date: FilterDate,
    };

    const filterList = autoLoadFilters ? [] : props.children;
    let modalClose;
    let modalOpen;
    let applyFilters;
    let contentLeft;
    let contentRight;
    let sidebarDetail;
    let reset;
    let totalResults;
    let searchComponent;
    let sortComponent;
    let activeFilters;
    let modalTitle;
    let resetFilters;
    let modalButtons;

    function toggleModal(e) {
        e.preventDefault();
        if (!modalVisible) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        setModalVisible(!modalVisible);
    }

    function hideModal() {
        if (window.matchMedia('(min-width: 992px)').matches) {
            document.body.style.overflow = '';
            setModalVisible(false);
        }
    }

    window.addEventListener('resize', throttle(hideModal, 100));

    function modalActiveClass() {
        let modalClassString = '';

        if (modalVisible) {
            modalClassString = 'modal-active';
        }

        return modalClassString;
    }

    if (Object.entries(selected).length !== 0 && autoLoadFilters) {
        for (const term in selected) {
            if (selected[term].length > 0) {
                activeFilters = true;
                break;
            }
        }
    }

    if (Object.entries(filters).length !== 0 && autoLoadFilters) {
        let i = 0;
        for (const taxonomy in filters) {
            const type = filters[taxonomy].type;
            const showLabel = filters[taxonomy].showLabel ?? true;
            const TheFilter = components[type];

            filterList.push(
                <TheFilter
                    key={i++}
                    label={filters[taxonomy].label}
                    taxonomy={filters[taxonomy].terms}
                    taxSlug={taxonomy}
                    selected={selected}
                    displayPostCounts={displayPostCounts}
                    collapsible={filters[taxonomy].collapsible}
                    scrollable={filters[taxonomy].scrollable}
                    dropdown={filters[taxonomy].dropdown}
                    filterReset={filterReset}
                    showLabel={showLabel}
                    resetSelected={resetSelected}
                    toggleSelected={toggleSelected}
                    replaceSelected={replaceSelected}
                    isSelected={isSelected}
                    setCurrentPage={setCurrentPage}
                    setChangedFilter = { setChangedFilter }
                    setFilterReset={setFilterReset}
                ></TheFilter>
            );
        }
    }

    if (mobileStyle === 'modal') {
        modalClose = (
            <button
                className='eight29-sidebar-toggle eight29-sidebar-close'
                onClick={(e) => {
                    toggleModal(e);
                }}
            >
                <CloseIcon></CloseIcon>
            </button>
        );

        modalOpen = (
            <div>
                <button
                    className='eight29-sidebar-toggle eight29-sidebar-open c-btn c-btn-secondary c-btn-color-normal'
                    onClick={(e) => {
                        toggleModal(e);
                    }}
                >
                    <FilterIcon className='app-icon'></FilterIcon>
                    Filter
                </button>
            </div>
        );

        modalTitle = (
            <div className='eight29-modal-title'>
                <FilterIconRed className='app-icon'></FilterIconRed>Filter
            </div>
        );

        applyFilters = (
            <div>
                <button
                    className='eight29-sidebar-toggle apply-filters c-btn c-btn-secondary c-btn-color-normal'
                    onClick={(e) => {
                        toggleModal(e);
                    }}
                >
                    Apply
                </button>
            </div>
        );

        resetFilters = (
            <div>
                <button
                    type='button'
                    className='reset-filters'
                    onClick={() => {
                        resetSelected();
                    }}
                >
                    Clear
                </button>
            </div>
        );

        modalButtons = (
            <div className='modal-buttons'>
                {applyFilters}
                {resetFilters}
            </div>
        );
    }

    if (displayResults) {
        totalResults = (
            <li>
                <span>Posts ({results})</span>
            </li>
        );
    }

    if (displayReset && activeFilters) {
        reset = (
            <li>
                <span className='eight29-reset-label'>Filter by: </span>
                <a
                    className='eight29-reset'
                    onClick={() => {
                        resetSelected();
                    }}
                >
                    <span>Clear Filters</span>
                </a>
            </li>
        );
    }

    if (displaySearch && ['default', 'faculty'].includes(layout)) {
        searchComponent = (
            <FilterSearch
                filterReset={filterReset}
                currentSearchTerm={currentSearchTerm}
                searchFieldChange={searchFieldChange}
                setFilterReset={setFilterReset}
                setCurrentPage={setCurrentPage}
                setChangedFilter={setChangedFilter}
            ></FilterSearch>
        );
    }

    if (displaySort && ['default', 'faculty'].includes(layout)) {
        sortComponent = (
            <FilterOrderBy
                order={order}
                orderChange={orderChange}
            ></FilterOrderBy>
        );
    }

    if (autoLoadFilters) {
        contentLeft = (
            <div className='eight29-filter-list left-content'>{filterList}</div>
        );
    } else {
        contentLeft = (
            <div className='eight29-filter-list left-content'>
                {sidebarLeft}
            </div>
        );
    }

    if (sidebarRight && layout !== 'default') {
        contentRight = (
            <div className='eight29-filter-list right-content'>
                {sidebarRight}
            </div>
        );
    }

    if (layout === 'default' && (reset || totalResults)) {
        sidebarDetail = (
            <ul className='eight29-sidebar-detail'>
                {reset}
                {totalResults}
            </ul>
        );
    }

    const content = (
        <div className='eight29-filter-group'>
            {sortComponent}
            {contentLeft}
            {contentRight}
        </div>
    );

    return (
        <form className={`eight29-sidebar ${modalActiveClass()} ${className}`}>
            {searchComponent}
            <div className='eight29-sidebar-content'>
                {modalTitle}
                {modalClose}
                {searchComponent}
                {sidebarDetail}
                {content}
                {modalButtons}
            </div>

            {modalOpen}
        </form>
    );
}

export default sidebar;
